export default __webpack_public_path__ + "static/media/dell_laptop.37e1512d.png";